import { render, staticRenderFns } from "./MemolanguageFacebookButton.vue?vue&type=template&id=551a0025&scoped=true&"
import script from "./MemolanguageFacebookButton.vue?vue&type=script&lang=js&"
export * from "./MemolanguageFacebookButton.vue?vue&type=script&lang=js&"
import style0 from "./MemolanguageFacebookButton.vue?vue&type=style&index=0&id=551a0025&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551a0025",
  null
  
)

export default component.exports